import { createComponent } from '@helpers/admin';
import NumberTransferSection from '@template/blocks/NumberTransferSection/component';

export const NumberTransfer = createComponent({
  label: 'Number Transfer',
  component: NumberTransferSection,
  fields: {
    altStyling: {
      type: 'boolean',
      label: 'Alternate Styling',
    },
  },
});
